import { TipoAplicacionModel } from "./tipoAplicacionModel";

export class AplicacionModel {

    tipoApp: TipoAplicacionModel;
    appDesc: string;
    appId: number;

    constructor() { }
}
